import { useEffect, useState } from "react";
import ClassHomeDemo2 from "../CommanComponents/ClassHomeDemo2";
import ClassHomeDemo3 from "../CommanComponents/ClassHomeDemo3";
import ClassHomeDemo4 from "../CommanComponents/ClassHomeDemo4";
import TeacherPage from "../teacher/TeacherPage";
import Navbar from "../CommanComponents/Navbar";
import { useSelector, useDispatch } from "react-redux";
import { scoreArray } from "../redux/slice/ScoreSlice";
import { contentArray } from "../redux/slice/ContentArraySlice";
import ExpiredPackageView from "../CommanComponents/ExpiredPackageView";
import api from "../utils/api";
import useModal from "../hooks/useModal";
import TrialModalOpen from "../Modals/TrialModalOpen";
import SEOHead from "../CommanComponents/SEOHead";

function Home() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [userName, setUserName] = useState("Öğrenci");
  const [yourClassroom, setYourClassroom] = useState(true);
  const { visable, Open, Close } = useModal();
  // 🆕 Deneme Pop-up State'i

  const count = useSelector((state) => state.activeComponent.value);
  const dispatch = useDispatch();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));
    if (!user) return;

    setUserName(user.username);

    // 1. Aşama: Rol Kontrolü (Teacher)
    if (user.role === "teacher") {
      setActiveCategory(4);
      return;
    }

    // 2. Aşama: Aktif Paket Kontrolü
    const currentDate = new Date();
    const activePackages = user.purchasedPackages
      ? user.purchasedPackages.filter(
          (item) => item.isActive && new Date(item.expiryDate) > currentDate,
        )
      : [];

    if (activePackages.length > 0) {
      // Aktif paketi varsa ilkine göre kategoriyi ayarla
      const item = activePackages[0];
      switch (item.packageId) {
        case "Class 2":
          setActiveCategory(count === 0 ? 1 : count);
          break;
        case "Class 3":
          setActiveCategory(count === 0 ? 2 : count);
          break;
        case "Class 4":
          setActiveCategory(count === 0 ? 3 : count);
          break;
        default:
          setActiveCategory(1);
          break;
      }
    }
    // 3. Aşama: Paket Yok VE Deneme Hakkını Kullanmadıysa -> Pop-up Aç!
    else if (!user.hasUsedTrial) {
      // setIsTrialModalOpen(true);
      Open("TrialModalOpen");
    }
    // 4. Aşama: Deneme Hakkını Kullanmış ve Paketi Bitmişse (İsteğe bağlı yönlendirme)
    else {
      setActiveCategory(0); // Veya ödeme/paket satın al sayfasına yönlendirme
    }
  }, [count]);

  // Skorları Çekme
  useEffect(() => {
    const fetchUserAndScore = async () => {
      const user = JSON.parse(localStorage.getItem("postUser"));
      if (user) {
        const scoreInfo = await getScore(user._id);
        if (scoreInfo) {
          dispatch(scoreArray(scoreInfo));
          const contentArrays = scoreInfo.contentArray || [];
          dispatch(contentArray(contentArrays));
        }
      }
    };
    fetchUserAndScore();
  }, []);

  const getScore = async () => {
    try {
      const res = await api.get("getUserByScore");
      return res.data;
    } catch (error) {
      console.error("Error get score:", error);
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col w-full justify-center items-center gap-4"
      style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
    >
      <SEOHead
        title="İlkokul İngilizce Eğitim Platformu"
        description="Classroom; ilkokul 2, 3 ve 4. sınıf öğrencileri için MEB müfredatına uygun, eğlenceli ve interaktif İngilizce öğrenme platformudur."
      />
      <div className="w-full rounded-2xl">
        <Navbar
          setActiveCategory={setActiveCategory}
          activeCategory={activeCategory}
        />
      </div>

      {yourClassroom ? (
        <div className="w-full">
          {activeCategory === 0 && <ExpiredPackageView />}
          {activeCategory === 1 && <ClassHomeDemo2 />}
          {activeCategory === 2 && <ClassHomeDemo3 />}
          {activeCategory === 3 && <ClassHomeDemo4 />}
          {activeCategory === 4 && <TeacherPage />}
        </div>
      ) : (
        <div>
          <h2 className="text-2xl font-bold">Welcome to Your Classroom</h2>
          <p className="mt-4">
            Here you can find all your classes and resources.
          </p>
        </div>
      )}
      <TrialModalOpen
        visable={visable.TrialModalOpen}
        Close={() => Close("TrialModalOpen")}
      />
    </div>
  );
}

export default Home;
